import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationStart } from '@angular/router';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { INDRANavigateAwayModalComponent } from '@ibe.components/shared/navigate-away-modal/navigate-away-modal.indra.component';
import { INDRAStorageService } from './storage.indra.service';
import { INDRAIbeAdminConfigService } from './ibeadmin-config.service';
import { Observable } from 'rxjs';
import { LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT, LOCAL_STORAGE_VAR_KEY_ROUTE_NAME, PAYMENT_LOGIN_STATE_ROUTE_NAME, PAYMENT_PASSENGERS_STATE_ROUTE_NAME, PAYMENT_CONTACTS_STATE_ROUTE_NAME, PAYMENT_PAYMENT_STATE_ROUTE_NAME, } from '@ibe.config';
import { INDRAURLService } from './url.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../components/common/modal/modal.indra.service";
import * as i3 from "./storage.indra.service";
import * as i4 from "../components/common/sidebar/sidebar.service";
import * as i5 from "./ibeadmin-config.service";
import * as i6 from "./url.indra.service";
var INDRABookingGuardService = /** @class */ (function () {
    function INDRABookingGuardService(router, modalService, storageService, sidebarService, ibeAdminConfigService, urlService) {
        var _this = this;
        this.router = router;
        this.modalService = modalService;
        this.storageService = storageService;
        this.sidebarService = sidebarService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.urlService = urlService;
        this.leaveConfirmed = false;
        this.hasNavigate = false;
        this.isBrowserNavigation = false;
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                _this.nextUrl = event['url'];
                _this.hasNavigate = router.navigated;
                if (event.navigationTrigger === 'popstate') {
                    _this.isBrowserNavigation = true;
                }
                else if (event.navigationTrigger === 'imperative') {
                    _this.isBrowserNavigation = false;
                }
            }
        });
    }
    INDRABookingGuardService.prototype.canActivate = function (route, state) {
        if (!this.isBrowserNavigation) {
            if ((this.router.url.search('/booking') >= 0 || this.router.url === '/booking')
                && !this.leaveConfirmed && !this.isBrowserNavigation) {
                if ((this.nextUrl === '/booking' || this.nextUrl === '/my-bookings' || this.nextUrl === '/check-in')
                    && this.router.url !== '/booking') {
                    this.INDRAcallModal(this.nextUrl, route.queryParams);
                    return false;
                }
                else {
                    return true;
                }
            }
            else if (this.leaveConfirmed) {
                // allow navigation if confirmed in modal
                this.leaveConfirmed = false;
                return true;
            }
            else if (!this.hasNavigate
                && state.url.search('/booking') >= 0
                && state.url !== '/booking'
                && state.url.search('/deeplink') <= 0
            // && state.url.search('/payment') <= 0
            ) {
                if (localStorage.getItem(LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT)) {
                    localStorage.removeItem(LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT);
                    if (localStorage.getItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME) === state.url ||
                        (localStorage.getItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME).includes(PAYMENT_PAYMENT_STATE_ROUTE_NAME) &&
                            (state.url.includes(PAYMENT_PAYMENT_STATE_ROUTE_NAME) ||
                                state.url.includes(PAYMENT_LOGIN_STATE_ROUTE_NAME) ||
                                state.url.includes(PAYMENT_PASSENGERS_STATE_ROUTE_NAME) ||
                                state.url.includes(PAYMENT_CONTACTS_STATE_ROUTE_NAME)))) {
                        localStorage.removeItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME);
                    }
                    else {
                        localStorage.removeItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME);
                        this.router.navigate(['/booking'], { queryParams: this.urlService.INDRA_getFilteredParams(route.queryParams) });
                    }
                    this.hasNavigate = true;
                    return true;
                }
                else {
                    this.router.navigate(['/booking'], { queryParams: this.urlService.INDRA_getFilteredParams(route.queryParams) });
                    this.hasNavigate = true;
                    return true;
                }
            }
            else if (state.url.includes('/deeplink') && !this.nextUrl && !this.hasNavigate) {
                return this.INDRA_checkConfigAppAvailable();
            }
            else {
                return true;
            }
        }
        else if (this.isBrowserNavigation) {
            if (this.hasNavigate && this.nextUrl === '/booking/payment') {
                // handle back navigation by browser when in booking view page or payment rejected scenario
                this.INDRA_returnToHome(route.queryParams);
                return false;
            }
            else if (this.router.url === '/booking') {
                // handle browser back navigation  from homepage after a completed booking
                this.sidebarService.closeSidebar();
                this.isBrowserNavigation = false;
                return false;
            }
            else if (this.nextUrl.includes('sidebar')) {
                // handle browser back if the previous url is from sidebar				
                // this.sidebarService.closeSidebar();
                // this.INDRA_returnToHome()
                // return false;
                return true;
            }
            else {
                return true;
            }
        }
    };
    INDRABookingGuardService.prototype.canActivateChild = function (route, state) {
        // check if navigating from child of /booking
        if (!this.isBrowserNavigation) {
            // if navigating to /booking due to session timeout allow navigation without confirmation modal
            // if bookAwardFlight navigating to /booking from logout allow navigation
            if (this.storageService.get('allow_navigate')) {
                this.storageService.remove('allow_navigate');
                return true;
            }
            else if ((this.nextUrl === '/booking' && this.router.url !== '/booking') &&
                this.router.url.search('/booking') >= 0 && !this.leaveConfirmed) {
                this.INDRAcallModal(this.nextUrl, route.queryParams);
                return false;
            }
            else {
                if (this.leaveConfirmed) {
                    this.leaveConfirmed = false;
                    return true;
                }
                else {
                    // if leaving from my-bookings page using header book link 
                    if (this.storageService.get('bookingPnr') && this.nextUrl === '/booking' && this.router.url.search('/my-bookings/view') >= 0) {
                        this.storageService.remove('bookingPnr');
                    }
                    return true;
                }
            }
        }
        else if (this.isBrowserNavigation) {
            // detect back navigation by browser, redirect to /booking homepage
            if (this.router.url.search('/booking') >= 0 && !this.leaveConfirmed
                && this.router.url !== '/booking') {
                this.INDRA_returnToHome(route.queryParams);
                return false;
            }
            else if (this.router.url === '/booking' && this.nextUrl !== '/booking' && !this.leaveConfirmed) {
                // handle browser back navigation if in homepage and is returned to home while booking
                this.sidebarService.closeSidebar();
                this.INDRA_returnToHome(route.queryParams);
                return false;
            }
        }
    };
    INDRABookingGuardService.prototype.INDRA_returnToHome = function (queryParams) {
        var _this = this;
        setTimeout(function () {
            _this.isBrowserNavigation = false;
            if (_this.router.url !== '/booking') {
                _this.leaveConfirmed = true;
                _this.router.navigate(['/booking'], { queryParams: _this.urlService.INDRA_getFilteredParams(queryParams) });
            }
        }, 500);
    };
    INDRABookingGuardService.prototype.INDRAcallModal = function (url, queryParams) {
        var _this = this;
        this.modalService.assignComponent(INDRANavigateAwayModalComponent);
        this.modalService.open();
        this.modalService.navigateAwaySelection$.subscribe(function (val) {
            if (val === true) {
                _this.leaveConfirmed = true;
                _this.router.navigate([url], { queryParams: _this.urlService.INDRA_getFilteredParams(queryParams) });
            }
        });
    };
    INDRABookingGuardService.prototype.INDRA_checkConfigAppAvailable = function () {
        var _this = this;
        // call configurations api for deeplinks to check if site is down, if sitedown do not call deeplink resolvers
        return new Observable(function (observer) {
            _this.ibeAdminConfigService.loadConfigurations('tap', ['externalURLs', 'insurance', 'Search', 'bookingSearch', 'bookingPayment']).subscribe(function (value) {
                if (value) {
                    var key = 'bookingSearch.appAvailable';
                    var isAppAvailable = _this.ibeAdminConfigService.getConfigurationValue(key);
                    if (isAppAvailable === 'false') {
                        _this.INDRA_navigateToSiteDown();
                        observer.next(false);
                        observer.complete();
                    }
                    else {
                        observer.next(true);
                        observer.complete();
                    }
                }
                else {
                    observer.next(true);
                    observer.complete();
                }
            }, function (error) {
                observer.next(true);
                observer.complete();
            });
        });
    };
    INDRABookingGuardService.prototype.INDRA_navigateToSiteDown = function () {
        var _this = this;
        setTimeout(function () {
            _this.router.navigate(['/notavailable']);
        }, 500);
    };
    INDRABookingGuardService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingGuardService_Factory() { return new INDRABookingGuardService(i0.inject(i1.Router), i0.inject(i2.ModalService), i0.inject(i3.INDRAStorageService), i0.inject(i4.SidebarService), i0.inject(i5.INDRAIbeAdminConfigService), i0.inject(i6.INDRAURLService)); }, token: INDRABookingGuardService, providedIn: "root" });
    return INDRABookingGuardService;
}());
export { INDRABookingGuardService };
